import React from 'react'

import {
  StyledContainer, StyledInput
} from './styles';

const InputField = ({ type, name, id, placeHolder, onChange }) => {
  return (
    <StyledContainer>
      <StyledInput
        id={id}
        type={type}
        name={name}
        placeholder={placeHolder}
        onChange={onChange}
        readOnly="readonly"
      />
    </StyledContainer>
  )
}

export default InputField
